import React from "react";
import { motion } from "framer-motion";

const AnimatedBanner = () => {
  const texts = [
    "PROFESJONALIZM",
    "JAKOŚĆ",
    "DOŚWIADCZENIE",
    "ZAUFANIE",
    "TRENINGI EMS",
    "ZDROWIE",
    "PROFESJONALIZM",
    "JAKOŚĆ",
    "DOŚWIADCZENIE",
    "ZAUFANIE",
    "TRENINGI EMS",
    "ZDROWIE",
  ];

  return (
    <section className="bg-[#191919] border-t border-white text-orange-500 uppercase flex justify-center items-center h-[300px] w-full overflow-hidden relative">
      <div className="flex space-x-10 animate-marquee">
        {texts.map((text, index) => (
          <motion.div
            key={index}
            className="text-3xl md:text-6xl font-bold whitespace-nowrap"
          >
            {text}
          </motion.div>
        ))}
        {texts.map((text, index) => (
          <motion.div
            key={`duplicate-${index}`}
            className="text-3xl md:text-6xl font-bold whitespace-nowrap"
          >
            {text}
          </motion.div>
        ))}
      </div>
      <style jsx>{`
        @keyframes marquee {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%); /* Move only half the width */
          }
        }
        .animate-marquee {
          display: flex;
          animation: marquee 50s linear infinite;
          width: max-content; /* Ensure the container fits the content */
        }
      `}</style>
    </section>
  );
};

export default AnimatedBanner;
